import React, {useState, useRef} from 'react';
import post from '../utils/post.js';
import validateEmail from '../utils/validateEmail.js';
import FormText from '../components/FormText.js';
import {Link} from 'react-router-dom';

export default function Login() {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [usernameError, setUsernameError] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState('Zadejte přihlašovací údaje');
	const [notActivated, setNotActivated] = useState(false);

	const usernameRef = useRef();
	const passwordRef = useRef();

	const handleSubmit = (e) => {
		e.preventDefault();

		setUsernameError('');
		setPasswordError('');

		let localError = '';

		if (!username) {
			localError = 'Vyplňte email';
			setUsernameError(localError);
			usernameRef.current.focus();
		} else if (!validateEmail(username)) {
			localError = 'Neplatný email';
			setUsernameError(localError);
			usernameRef.current.focus();
		} else if (!password) {
			localError = 'Vyplňte heslo';
			setPasswordError(localError);
			passwordRef.current.focus();
		}

		if (!localError) {
			setLoading(true);

			post('login', {username, password})
				.then((res) => {
					if (res.data.usrId) {
						if (res.data.token) {
							localStorage.setItem('token', res.data.token);
						}
						
						window.location.pathname = '/';
					} else {
						setNotActivated(!!res.data.notActivated);
						setResult(res.data.resultTxt);
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<div className="login">
			{loading ? <div className="loading" /> : ''}

			<div className="login_shell">
				<div className="login_brand">
					<img className="login_logo" alt="" />
				</div>
				<div className="login_container auth-card auth-card--wide">
					<div className="login_container_in auth-card__body">
						<h1 className="auth-card__title">Přihlášení</h1>
						<p className="auth-card__text">Přihlas se ke svému účtu a pokračuj do aplikace.</p>

						<form method="POST" onSubmit={handleSubmit} className="auth-form auth-form--login">
							<div className="auth-form__field auth-form__field--full">
								<FormText type="text" label="Email" value={username} setValue={setUsername} ref={usernameRef} error={usernameError} />
							</div>
							<div className="auth-form__field auth-form__field--full">
								<FormText type="password" label="Heslo" value={password} setValue={setPassword} ref={passwordRef} error={passwordError} />
							</div>
							<div className="auth-form__actions">
								<input type="submit" name="button_login" value="Přihlásit" className="button auth-pill-button" disabled={loading} />
							</div>
							<div className={'login_result auth-result ' + (notActivated ? 'auth-result--warning' : 'fnt_orange')}>{result}</div>
						</form>

						<div className="auth-links auth-links--split">
							<Link to={'/register'} key="lnk_register" className="lnk1 auth-link">
								Registrace
							</Link>
							<Link to={'/forget'} key="lnk_forget" className="lnk1 auth-link auth-link--align-end">
								Zapomenuté heslo
							</Link>
						</div>
						<div className="auth-links auth-links--center">
							<Link to={'/'} key="lnk_login" className="lnk1 auth-link">
								Zpět na úvodní stránku
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
